import { render } from "./resourceProjects.vue?vue&type=template&id=ba51bc02"
import script from "./resourceProjects.vue?vue&type=script&lang=js"
export * from "./resourceProjects.vue?vue&type=script&lang=js"

import "./resourceProjects.less?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__